import { z } from 'zod';

/** What a person can send from the feedback widget. */
export const FEEDBACK_KINDS = ['feedback', 'bug', 'idea'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const FEEDBACK_KIND_LABEL: Record<FeedbackKind, string> = {
  feedback: 'Feedback',
  bug: 'Bug',
  idea: 'Idea',
};

export const FEEDBACK_MAX_CHARS = 2000;

export const feedbackInput = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  message: z.string().trim().min(1).max(FEEDBACK_MAX_CHARS),
  url: z.string().max(2000),
});
export type FeedbackInput = z.infer<typeof feedbackInput>;

/** Path segments that are credentials: a physician's secure link, an account invitation. */
const SECRET_PATHS: readonly [RegExp, string][] = [
  [/\/respond\/[^/]+/, '/respond/[secure link]'],
  [/\/welcome\/[^/]+/, '/welcome/[invitation link]'],
];

/**
 * The page a report came from, safe to store: origin and path only. Query strings and
 * fragments are dropped (magic links carry their credential there) and credential path
 * segments are replaced, so a feedback row never holds a working link.
 */
export function feedbackPageUrl(raw: string): string {
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    return '';
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';
  let path = u.pathname;
  for (const [re, label] of SECRET_PATHS) path = path.replace(re, label);
  return `${u.origin}${path}`;
}
